
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerStack1 from "../../editor/platform-markers/cave/PlatformMarkerStack1";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import TrapMarkerTorch from "../../editor/trap-markers/cave/TrapMarkerTorch";
import PlatformMarkerPlatMini from "../../editor/platform-markers/cave/PlatformMarkerPlatMini";
import PlatformMarkerPillar from "../../editor/platform-markers/cave/PlatformMarkerPillar";
import PlatformMarkerStack2 from "../../editor/platform-markers/cave/PlatformMarkerStack2";
import PlatformMarkerPlatMid from "../../editor/platform-markers/cave/PlatformMarkerPlatMid";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerPlat from "../../editor/platform-markers/cave/PlatformMarkerPlat";
import MoverData from "../../../components/platformer/MoverData";
import PositionMarker from "../../editor/PositionMarker";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveChunk4 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? -381.58257912127925, y ?? 178.22467347422582);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 233, 368);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 6305, 368);
    this.add(editor_bounds_right);

    // platformMarkerStack_1
    const platformMarkerStack_1 = new PlatformMarkerStack1(scene, 2977, 324);
    this.add(platformMarkerStack_1);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 3704, -607);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 2236, 127);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2100, 130);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2363, 130);
    this.add(gemMarker_3);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 1537, -87);
    this.add(gemMarker_12);

    // platformMarkerStack_12
    const platformMarkerStack_12 = new PlatformMarkerStack3(scene, 5677, 288);
    this.add(platformMarkerStack_12);

    // platformMarkerStack_13
    const platformMarkerStack_13 = new PlatformMarkerStack3(scene, 5930, 284);
    this.add(platformMarkerStack_13);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 3466, 68);
    this.add(gemMarker_15);

    // trapMarkerTorch_6
    const trapMarkerTorch_6 = new TrapMarkerTorch(scene, 1764, 177);
    this.add(trapMarkerTorch_6);

    // gemMarker_17
    const gemMarker_17 = new SmallGemMarker(scene, 1558, 167);
    this.add(gemMarker_17);

    // gemMarker_18
    const gemMarker_18 = new SmallGemMarker(scene, 1181, 164);
    this.add(gemMarker_18);

    // gemMarker_25
    const gemMarker_25 = new SmallGemMarker(scene, 3308, 70);
    this.add(gemMarker_25);

    // gemMarker_26
    const gemMarker_26 = new SmallGemMarker(scene, 5796, 88);
    this.add(gemMarker_26);

    // gemMarker_27
    const gemMarker_27 = new SmallGemMarker(scene, 5274, -183);
    this.add(gemMarker_27);

    // platformMarkerPlatMini
    const platformMarkerPlatMini = new PlatformMarkerPlatMini(scene, 1528, -20);
    this.add(platformMarkerPlatMini);

    // platformMarkerPillar_2
    const platformMarkerPillar_2 = new PlatformMarkerPillar(scene, 1193, 293);
    this.add(platformMarkerPillar_2);

    // platformMarkerStack2
    const platformMarkerStack2 = new PlatformMarkerStack2(scene, 2039, 303);
    this.add(platformMarkerStack2);

    // platformMarkerStack
    const platformMarkerStack = new PlatformMarkerStack2(scene, 2411, 303);
    this.add(platformMarkerStack);

    // platformMarkerPlatMid_1
    const platformMarkerPlatMid_1 = new PlatformMarkerPlatMid(scene, 2227, 217);
    this.add(platformMarkerPlatMid_1);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 2975, 244);
    this.add(megaGemMarker_2);

    // platformMarkerPlatMini_3
    const platformMarkerPlatMini_3 = new PlatformMarkerPlatMini(scene, 3441, -457);
    this.add(platformMarkerPlatMini_3);

    // platformMarkerPlatMini_5
    const platformMarkerPlatMini_5 = new PlatformMarkerPlatMini(scene, 3987, -453);
    this.add(platformMarkerPlatMini_5);

    // gemMarker_29
    const gemMarker_29 = new SmallGemMarker(scene, 5101, 176);
    this.add(gemMarker_29);

    // platformMarkerPlat_2
    const platformMarkerPlat_2 = new PlatformMarkerPlat(scene, 1942, -254);
    this.add(platformMarkerPlat_2);

    // platformMarkerPlatMid_3
    const platformMarkerPlatMid_3 = new PlatformMarkerPlatMid(scene, 3106, -525);
    this.add(platformMarkerPlatMid_3);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 4100, 185);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 4603, 187);
    this.add(megaGemMarker_1);

    // platformMarkerPlat_3
    const platformMarkerPlat_3 = new PlatformMarkerPlat(scene, 5283, -97);
    this.add(platformMarkerPlat_3);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 488, 131);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 365, 134);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 628, 134);
    this.add(gemMarker_7);

    // platformMarkerStack_2
    const platformMarkerStack_2 = new PlatformMarkerStack2(scene, 304, 307);
    this.add(platformMarkerStack_2);

    // platformMarkerStack_3
    const platformMarkerStack_3 = new PlatformMarkerStack2(scene, 676, 307);
    this.add(platformMarkerStack_3);

    // platformMarkerPlatMid_4
    const platformMarkerPlatMid_4 = new PlatformMarkerPlatMid(scene, 492, 221);
    this.add(platformMarkerPlatMid_4);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 1937, -259);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 2092, -259);
    this.add(positionMarker_1);

    // platformMarkerPlat_4
    const platformMarkerPlat_4 = new PlatformMarkerPlat(scene, 5799, 172);
    this.add(platformMarkerPlat_4);

    // platformMarkerPillar
    const platformMarkerPillar = new PlatformMarkerPillar(scene, 1563, 297);
    this.add(platformMarkerPillar);

    // platformMarkerPillar_1
    const platformMarkerPillar_1 = new PlatformMarkerPillar(scene, 1766, 301);
    this.add(platformMarkerPillar_1);

    // platformMarkerPillar_3
    const platformMarkerPillar_3 = new PlatformMarkerPillar(scene, 2726, 293);
    this.add(platformMarkerPillar_3);

    // platformMarkerPlat
    const platformMarkerPlat = new PlatformMarkerPlat(scene, 4814, -330);
    this.add(platformMarkerPlat);

    // positionMarker_2
    const positionMarker_2 = new PositionMarker(scene, 4809, -335);
    this.add(positionMarker_2);

    // positionMarker_3
    const positionMarker_3 = new PositionMarker(scene, 4943, -336);
    this.add(positionMarker_3);

    // platformMarkerStack_4
    const platformMarkerStack_4 = new PlatformMarkerStack3(scene, 3267, 270);
    this.add(platformMarkerStack_4);

    // platformMarkerStack_5
    const platformMarkerStack_5 = new PlatformMarkerStack3(scene, 3520, 266);
    this.add(platformMarkerStack_5);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 3386, 70);
    this.add(gemMarker_8);

    // platformMarkerPlat_1
    const platformMarkerPlat_1 = new PlatformMarkerPlat(scene, 3389, 154);
    this.add(platformMarkerPlat_1);

    // trapMarkerTorch
    const trapMarkerTorch = new TrapMarkerTorch(scene, 2728, 166);
    this.add(trapMarkerTorch);

    // platformMarkerPillar_4
    const platformMarkerPillar_4 = new PlatformMarkerPillar(scene, 3810, 300);
    this.add(platformMarkerPillar_4);

    // trapMarkerTorch_1
    const trapMarkerTorch_1 = new TrapMarkerTorch(scene, 3807, 172);
    this.add(trapMarkerTorch_1);

    // platformMarkerPillar_5
    const platformMarkerPillar_5 = new PlatformMarkerPillar(scene, 4352, 299);
    this.add(platformMarkerPillar_5);

    // trapMarkerTorch_2
    const trapMarkerTorch_2 = new TrapMarkerTorch(scene, 4347, 173);
    this.add(trapMarkerTorch_2);

    // platformMarkerPillar_6
    const platformMarkerPillar_6 = new PlatformMarkerPillar(scene, 4861, 297);
    this.add(platformMarkerPillar_6);

    // trapMarkerTorch_3
    const trapMarkerTorch_3 = new TrapMarkerTorch(scene, 4858, 173);
    this.add(trapMarkerTorch_3);

    // platformMarkerPillar_7
    const platformMarkerPillar_7 = new PlatformMarkerPillar(scene, 4104, 297);
    this.add(platformMarkerPillar_7);

    // platformMarkerPillar_8
    const platformMarkerPillar_8 = new PlatformMarkerPillar(scene, 4608, 294);
    this.add(platformMarkerPillar_8);

    // platformMarkerPillar_9
    const platformMarkerPillar_9 = new PlatformMarkerPillar(scene, 5110, 296);
    this.add(platformMarkerPillar_9);

    // platformMarkerPlat_5
    const platformMarkerPlat_5 = new PlatformMarkerPlat(scene, 3704, -521);
    this.add(platformMarkerPlat_5);

    // platformMarkerPlatMid
    const platformMarkerPlatMid = new PlatformMarkerPlatMid(scene, 4330, -525);
    this.add(platformMarkerPlatMid);

    // trapMarkerTorch_4
    const trapMarkerTorch_4 = new TrapMarkerTorch(scene, 3443, -549);
    this.add(trapMarkerTorch_4);

    // trapMarkerTorch_5
    const trapMarkerTorch_5 = new TrapMarkerTorch(scene, 3988, -545);
    this.add(trapMarkerTorch_5);

    // platformMarkerPlat_6
    const platformMarkerPlat_6 = new PlatformMarkerPlat(scene, 2383, -449);
    this.add(platformMarkerPlat_6);

    // platformMarkerPlatMini_2
    const platformMarkerPlatMini_2 = new PlatformMarkerPlatMini(scene, 2702, -400);
    this.add(platformMarkerPlatMini_2);

    // trapMarkerTorch_7
    const trapMarkerTorch_7 = new TrapMarkerTorch(scene, 2704, -492);
    this.add(trapMarkerTorch_7);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 3104, -605);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 2968, -602);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 3231, -602);
    this.add(gemMarker_11);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 4318, -605);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 4182, -602);
    this.add(gemMarker_14);

    // gemMarker_16
    const gemMarker_16 = new SmallGemMarker(scene, 4445, -602);
    this.add(gemMarker_16);

    // gemMarker_21
    const gemMarker_21 = new SmallGemMarker(scene, 2381, -532);
    this.add(gemMarker_21);

    // platformMarkerPillar_10
    const platformMarkerPillar_10 = new PlatformMarkerPillar(scene, 5410, 302);
    this.add(platformMarkerPillar_10);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 5405, 176);
    this.add(gemMarker_4);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 362, 185);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 2970, -563);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 4179, -563);
    this.add(checkpointMarker_2);

    // checkpointMarker_3
    const checkpointMarker_3 = new CheckpointMarker(scene, 5167, -146);
    this.add(checkpointMarker_3);

    // checkpointMarker_4
    const checkpointMarker_4 = new CheckpointMarker(scene, 5737, 128);
    this.add(checkpointMarker_4);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // platformMarkerPlat_2 (components)
    const platformMarkerPlat_2MoverData = new MoverData(platformMarkerPlat_2);
    platformMarkerPlat_2MoverData.startMarker = positionMarker;
    platformMarkerPlat_2MoverData.endMarker = positionMarker_1;

    // platformMarkerPlat (components)
    const platformMarkerPlatMoverData = new MoverData(platformMarkerPlat);
    platformMarkerPlatMoverData.startMarker = positionMarker_2;
    platformMarkerPlatMoverData.endMarker = positionMarker_3;
    platformMarkerPlatMoverData.startWait = 250;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
